import axios from '../axiosInstance';

const baseurlop ='/operation'
const baseurlReport ='/Reports'
class ChecklistService{

    getChecklist(consignmentId){
        return axios.get(baseurlop+'/getChecklist?consignmentId='+consignmentId)
    }
    getJobTrackingDetails(consignmentNumber){
        return axios.get(baseurlop+'/getJobTrackingDetails?consignmentNumber='+consignmentNumber)
    }
    getChecklistAPPVERISUBMISSION(consignmentId){
        return axios.get(baseurlop+'/getChecklistAPPVERISUBMISSION?consignmentId='+consignmentId)
    }
    getCustomerMailId(importer_iec_no){
        return axios.get(baseurlop+'/getCustomerMailId?importer_iec_no='+importer_iec_no)
    }
    getsenderMailId(createdBy){
        return axios.get(baseurlop+'/getsenderMailId?createdBy='+createdBy)
    }
    updateChecklistApproval(details){
        return axios.put(baseurlop+'/updateChecklistApproval',details)
    }
    updateChecklistSendDate(details){
        return axios.put(baseurlop+'/updateChecklistSendDate',details)
    }
    updateChecklistVerification(details){
        return axios.put(baseurlop+'/updateChecklistVerification',details)
    }
    sendMail(details){
        return axios.post(baseurlReport+'/sendMail',details)
    }
    getPDF(consignmentId){
        return axios.get(baseurlReport+'/getPDF?consignmentId='+consignmentId)
    }
    
}

export default new ChecklistService();